import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { BuzzlyLogo } from "@/components/BuzzlyLogo";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function PaymentResult({ cancelled }) {
  const [params] = useSearchParams();
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const { refresh } = useAuth();

  useEffect(() => {
    const sid = params.get("session_id");
    if (cancelled || !sid) return undefined;
    let tries = 0;
    const id = setInterval(async () => {
      tries += 1;
      try {
        const s = await api.paymentStatus(sid);
        if (s.status === "completed") {
          clearInterval(id);
          await refresh();
          setState("ok");
        }
      } catch { /* keep polling */ }
      if (tries > 20) { clearInterval(id); setState("timeout"); }
    }, 2000);
    return () => clearInterval(id);
  }, [cancelled, params, refresh]);

  const content = {
    checking: [Loader2, "Confirmation de votre essai…", "Merci de patienter quelques secondes.", "animate-spin text-[#1877f2]"],
    ok: [CheckCircle2, "Votre essai de 7 jours est activé !", "Votre agent BuzzlyMe est prêt. Ajoutez vos blogueurs et lancez votre première veille.", "text-[#31a24c]"],
    timeout: [Loader2, "Confirmation en cours", "Le paiement prend plus de temps que prévu. Rechargez le dashboard dans un instant.", "text-[#e4a11b]"],
    cancelled: [XCircle, "Paiement annulé", "Aucun montant n'a été débité. Vous pouvez réessayer quand vous voulez.", "text-[#c8102e]"],
  }[state];
  const [Icon, title, text, cls] = content;
  return (
    <div className="min-h-screen bg-[#f0f2f5] flex flex-col items-center justify-center px-4" data-testid="payment-result">
      <BuzzlyLogo />
      <div className="mt-8 bg-white rounded-2xl shadow-sm p-8 max-w-md w-full text-center fade-up">
        <Icon className={`w-12 h-12 mx-auto ${cls}`} />
        <h1 className="font-display text-2xl font-extrabold mt-4" data-testid="payment-result-title">{title}</h1>
        <p className="text-[#65676b] mt-2 text-sm">{text}</p>
        <Link to={state === "ok" ? "/app/agent" : "/app"} className="btn-primary mt-6 inline-flex" data-testid="payment-continue-btn">
          {state === "ok" ? "Configurer mon agent" : "Retour au dashboard"}
        </Link>
      </div>
    </div>
  );
}
